// A vacant role: nobody fills it and it holds no sub-role (a circle with
// sub-roles is not a role). Shared by the vacant roles panel and the org chart
// emphasis, so both always show the same roles.
export function getVacantRoles<
  C extends { id: string; parentId?: string | null },
>(
  circles: readonly C[],
  membersOf: (circleId: string) => readonly unknown[]
): C[] {
  const parentIds = new Set(circles.map((c) => c.parentId))
  return circles.filter(
    (c) => membersOf(c.id).length === 0 && !parentIds.has(c.id)
  )
}
